import { RouteName, RoutePath, ScreenName } from '@helpcenter/constants';
import { ViewCustomPageResource } from '@helpcenter/custom-page-resources/src/view-custom-page/resources';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';
import { ViewCustomPageWithAiAgent } from '@atlassian/help-center-custom-pages';
import { brandingResource } from '../advanced-help-center/resources/multi-help-centers';

export const getViewCustomPageRoute = (
    name: string = RouteName.VIEW_CUSTOM_PAGE,
    path: string = RoutePath.VIEW_CUSTOM_PAGE
) => {
    const viewCustomPageSSRResources = [brandingResource, ViewCustomPageResource];
    return createRouteWithLayout(
        {
            name,
            path,
            exact: true,
            component: ViewCustomPageWithAiAgent,
            resources: __SERVER__ ? viewCustomPageSSRResources : [ViewCustomPageResource],
        },
        ScreenName.VIEW_CUSTOM_PAGE,
        {
            paperAppearance: 'none',
            fadeInSearchModal: true,
            hideSearchButton: true,
            hideBanner: true,
            removeHeader: true,
            prefetchBrandingModel: true,
        }
    );
};
